import { useEffect, useState } from 'react';
import { useApiQuota } from '@/hooks/useApiQuota';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Progress } from '@/components/ui/progress';
import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

export function QuotaStatusBanner() {
  const { quotaStatus, checkQuota } = useApiQuota('analysis');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    checkQuota();
    const interval = setInterval(checkQuota, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, [checkQuota]);

  useEffect(() => {
    // Show banner when quota is above 50%
    if (quotaStatus && quotaStatus.percentUsed >= 50) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [quotaStatus]);

  if (!isVisible || !quotaStatus) return null;

  const getStatusColor = () => {
    if (quotaStatus.percentUsed >= 90) return 'destructive';
    if (quotaStatus.percentUsed >= 80) return 'default';
    return 'default';
  };

  const getIcon = () => {
    if (quotaStatus.percentUsed >= 90) return <XCircle className="w-4 h-4" />;
    if (quotaStatus.percentUsed >= 80) return <AlertTriangle className="w-4 h-4" />;
    return <CheckCircle className="w-4 h-4" />;
  };

  return (
    <Alert variant={getStatusColor()} className="mb-4">
      <div className="flex items-center gap-2">
        {getIcon()}
        <AlertDescription className="flex-1">
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">
                API Quota: {quotaStatus.requestsUsed}/{quotaStatus.requestsLimit} requests used
              </span>
              <span className="text-xs text-muted-foreground">
                Resets at {quotaStatus.resetAt.toLocaleTimeString()}
              </span>
            </div>
            <Progress value={quotaStatus.percentUsed} className="h-2" />
            {quotaStatus.percentUsed >= 90 && (
              <p className="text-xs text-muted-foreground">
                ⚠️ You're approaching your hourly limit. Requests will be throttled when exceeded.
              </p>
            )}
          </div>
        </AlertDescription>
      </div>
    </Alert>
  );
}
